import React from 'react';
import { useNavigate } from 'react-router';

import styled from '@emotion/styled';

import LeftChevronIcon from '../Icons/LeftChevronIcon';

interface BackToPreviousPageButtonProps {
  path: string;
  compFn?: (...args: any) => React.ReactNode;
}

const BackToPreviousPageButton: React.FC<BackToPreviousPageButtonProps> = ({
  path,
  compFn,
}) => {
  const navigate = useNavigate();

  return (
    <Container>
      <LeftButton onClick={() => navigate(`/${path}`)}>
        <LeftChevronIcon /> Back to Driver List
      </LeftButton>
      {compFn && compFn()}
    </Container>
  );
};

export default BackToPreviousPageButton;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const LeftButton = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${({ theme }) => theme.palette.blueColor};
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;

  & > svg {
    transition: all 0.2s ease-in-out;
  }

  &:hover {
    & > svg {
      transform: translateX(-4px);
    }
  }
`;
